export enum ProjectCode {
  PM = 'pm',
  PARTNER = 'partner',
  BANK = 'bank',
  SIGMA = 'sigma',
}
